import React from 'react'
import {useTranslation} from 'react-i18next'
import {Button, Col, Modal, Row, Typography} from 'antd'

import styles from './BankAccountCard.scss'

type BankAccountDeleteConfirmationModalProps = {
    open: boolean
    onClose: () => void
}

export const BankAccountDeleteConfirmationModal: React.FC<BankAccountDeleteConfirmationModalProps> = ({
    open,
    onClose
}) => {
    const {t} = useTranslation()

    return (
        <Modal
            className={styles.modal}
            open={open}
            title={
                <Typography.Title level={3} className={styles.modalTitle}>
                    {t('BankAccountCard.titles.bankAccountRemoved')}
                </Typography.Title>
            }
            closable={false}
            onCancel={onClose}
            footer={
                <Row justify={'space-around'} className={styles.modalFooter}>
                    <Col>
                        <Button size={'large'} onClick={onClose} className={styles.modalButton}>
                            {t('BankAccountCard.buttons.ok')}
                        </Button>
                    </Col>
                </Row>
            }
        >
            {t('BankAccountCard.messages.removedSuccess')}
        </Modal>
    )
}
